export const baseUrl = "/api"

export class ApiError extends Error {
	context?: Record<string, any> | null

	constructor(message: string, context?: Record<string, any> | null) {
		super(message)
		if (context) {
			this.context = context
		}
	}
}

export class FormError extends ApiError {
	fields: string[] = []

	constructor(message: string, context?: Record<string, any> | null) {
		super(message)

		if (context) {
			this.context = context
		}

		if (context && context.fields) {
			this.fields = context.fields
		}
	}
}

function withToken(headers: Record<string, string>, token: string) {
	return {
		...headers,
		Authorization: token,
	}
}

export function apiGet(url: string, token: string | null) {
	let headers: Record<string, string> = {
		"Content-Type": "application/json",
	}

	if (token) {
		headers = withToken(headers, token)
	}

	return fetch(`${baseUrl}/${url}`, {
		method: "GET",
		mode: "cors",
		headers,
	})
}

export function apiPost(url: string, body: any, token?: string | null) {
	let headers: Record<string, string> = {
		"Content-Type": "application/json",
	}

	if (token) {
		headers = withToken(headers, token)
	}

	return fetch(`${baseUrl}/${url}`, {
		method: "POST",
		mode: "cors",
		headers,
		body: JSON.stringify(body),
	})
}
